export default "__VITE_ASSET__CDgPOTY4__"